import 'dayjs/locale/en';
import 'dayjs/locale/lt';
import 'dayjs/locale/lv';
import 'dayjs/locale/ru';
import 'dayjs/locale/et';

import { LicenseInfo } from '@mui/x-license';
import { StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';

import Router from './routes';
import ThemeProvider from './theme';
import useLocales from './hooks/useLocales';
import RtlLayout from './components/RtlLayout';
import GlobalStyles from './theme/globalStyles';
import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './contexts/JWTContext';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import ThemeColorPresets from './components/ThemeColorPresets';
import ThemeLocalization from './components/ThemeLocalization';
import { AppSettingsProvider } from './contexts/AppSettingsContext';
import { PrevLocationProvider } from './contexts/PrevLocationContext';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import ConfirmationModalContextProvider from './contexts/ConfirmationModalContext'; // ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function App() {
  const { currentLang } = useLocales();

  // expiration Oct 23, 2027
  LicenseInfo.setLicenseKey(
    'fbbb5b88d3dadff9788fc1140fb7ce8fTz0xMzQwNjAsRT0xODI0MzM1OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MSxBVD1zaW5nbGUsS1Y9Mg=='
  );

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={currentLang.value === 'ee' ? 'et' : currentLang.value}
      dateFormats={{ keyboardDate: 'YYYY-MM-DD' }}
    >
      <StyledEngineProvider injectFirst>
        <ThemeProvider>
          <ThemeColorPresets>
            <ThemeLocalization>
              <RtlLayout>
                <NotistackProvider>
                  <MotionLazyContainer>
                    <ConfirmationModalContextProvider>
                      <AuthProvider>
                        <AppSettingsProvider>
                          <PrevLocationProvider>
                            <GlobalStyles />
                            <ProgressBarStyle />
                            <ChartStyle />
                            <ScrollToTop />
                            <Router />
                          </PrevLocationProvider>
                        </AppSettingsProvider>
                      </AuthProvider>
                    </ConfirmationModalContextProvider>
                  </MotionLazyContainer>
                </NotistackProvider>
              </RtlLayout>
            </ThemeLocalization>
          </ThemeColorPresets>
        </ThemeProvider>
      </StyledEngineProvider>
    </LocalizationProvider>
  );
}
